function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { toString } from "./util.mjs";
import { getStickyBucketAttributeKey } from "./core.mjs";
/**
 * Responsible for reading and writing documents which describe sticky bucket assignments.
 */
export var StickyBucketService = /*#__PURE__*/function () {
  function StickyBucketService(opts) {
    _classCallCheck(this, StickyBucketService);
    opts = opts || {};
    this.prefix = opts.prefix || "";
  }
  /**
   * The SDK calls getAllAssignments to populate sticky buckets. This in turn will
   * typically loop through individual getAssignments calls. However, some StickyBucketService
   * instances (i.e. Redis) will instead perform a multi-query inside getAllAssignments instead.
   */
  return _createClass(StickyBucketService, [{
    key: "getAllAssignments",
    value: (function () {
      var _getAllAssignments = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(attributes) {
        var _this = this;
        var docs;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              docs = {};
              _context.n = 1;
              return Promise.all(Object.entries(attributes).map(function (_ref) {
                var _ref7 = _slicedToArray(_ref, 2),
                  attributeName = _ref7[0],
                  attributeValue = _ref7[1];
                return _this.getAssignments(attributeName, attributeValue);
              }));
            case 1:
              _context.v.forEach(function (doc) {
                if (doc) {
                  var key = getStickyBucketAttributeKey(doc.attributeName, doc.attributeValue);
                  docs[key] = doc;
                }
              });
              return _context.a(2, docs);
          }
        }, _callee);
      }));
      function getAllAssignments(_x) {
        return _getAllAssignments.apply(this, arguments);
      }
      return getAllAssignments;
    }())
  }, {
    key: "getKey",
    value: function getKey(attributeName, attributeValue) {
      return "".concat(this.prefix).concat(attributeName, "||").concat(attributeValue);
    }
  }]);
}();
export var StickyBucketServiceSync = /*#__PURE__*/function (_StickyBucketService) {
  function StickyBucketServiceSync() {
    _classCallCheck(this, StickyBucketServiceSync);
    return _callSuper(this, StickyBucketServiceSync, arguments);
  }
  _inherits(StickyBucketServiceSync, _StickyBucketService);
  return _createClass(StickyBucketServiceSync, [{
    key: "getAssignments",
    value: function () {
      var _getAssignments = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(attributeName, attributeValue) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              return _context2.a(2, this.getAssignmentsSync(attributeName, attributeValue));
          }
        }, _callee2, this);
      }));
      function getAssignments(_x2, _x3) {
        return _getAssignments.apply(this, arguments);
      }
      return getAssignments;
    }()
  }, {
    key: "saveAssignments",
    value: function () {
      var _saveAssignments = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(doc) {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.saveAssignmentsSync(doc);
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function saveAssignments(_x4) {
        return _saveAssignments.apply(this, arguments);
      }
      return saveAssignments;
    }()
  }, {
    key: "getAllAssignmentsSync",
    value: function getAllAssignmentsSync(attributes) {
      var _this2 = this;
      var docs = {};
      Object.entries(attributes).map(function (_ref2) {
        var _ref8 = _slicedToArray(_ref2, 2),
          attributeName = _ref8[0],
          attributeValue = _ref8[1];
        return _this2.getAssignmentsSync(attributeName, attributeValue);
      }).forEach(function (doc) {
        if (doc) {
          var key = getStickyBucketAttributeKey(doc.attributeName, doc.attributeValue);
          docs[key] = doc;
        }
      });
      return docs;
    }
  }]);
}(StickyBucketService);
export var LocalStorageStickyBucketService = /*#__PURE__*/function (_StickyBucketService2) {
  function LocalStorageStickyBucketService(opts) {
    var _this3;
    _classCallCheck(this, LocalStorageStickyBucketService);
    opts = opts || {};
    _this3 = _callSuper(this, LocalStorageStickyBucketService);
    _this3.prefix = opts.prefix || "gbStickyBuckets__";
    try {
      _this3.localStorage = opts.localStorage || globalThis.localStorage;
    } catch (e) {
      // Ignore localStorage errors
    }
    return _this3;
  }
  _inherits(LocalStorageStickyBucketService, _StickyBucketService2);
  return _createClass(LocalStorageStickyBucketService, [{
    key: "getAssignments",
    value: function () {
      var _getAssignments2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(attributeName, attributeValue) {
        var key, doc, raw, data, _t, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              key = this.getKey(attributeName, attributeValue);
              doc = null;
              if (this.localStorage) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2, doc);
            case 1:
              _context4.p = 1;
              _context4.n = 2;
              return this.localStorage.getItem(key);
            case 2:
              _t = _context4.v;
              if (_t) {
                _context4.n = 3;
                break;
              }
              _t = "{}";
            case 3:
              raw = _t;
              data = JSON.parse(raw);
              if (data.attributeName && data.attributeValue && data.assignments) {
                doc = data;
              }
              _context4.n = 5;
              break;
            case 4:
              _context4.p = 4;
              _t2 = _context4.v;
            case 5:
              return _context4.a(2, doc);
          }
        }, _callee4, this, [[1, 4]]);
      }));
      function getAssignments(_x5, _x6) {
        return _getAssignments2.apply(this, arguments);
      }
      return getAssignments;
    }()
  }, {
    key: "saveAssignments",
    value: function () {
      var _saveAssignments2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(doc) {
        var key, _t3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              key = this.getKey(doc.attributeName, doc.attributeValue);
              if (this.localStorage) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              _context5.p = 1;
              _context5.n = 2;
              return this.localStorage.setItem(key, JSON.stringify(doc));
            case 2:
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t3 = _context5.v;
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this, [[1, 3]]);
      }));
      function saveAssignments(_x7) {
        return _saveAssignments2.apply(this, arguments);
      }
      return saveAssignments;
    }()
  }]);
}(StickyBucketService);
export var ExpressCookieStickyBucketService = /*#__PURE__*/function (_StickyBucketServiceS) {
  /**
   * Intended to be used with cookieParser() middleware from npm: 'cookie-parser'.
   * Assumes:
   *  - reading a cookie is automatically decoded via decodeURIComponent() or similar
   *  - writing a cookie name & value must be manually encoded via encodeURIComponent() or similar
   *  - all cookie bodies are JSON encoded strings and are manually encoded/decoded
   */

  function ExpressCookieStickyBucketService(_ref3) {
    var _this4;
    _classCallCheck(this, ExpressCookieStickyBucketService);
    var _ref3$prefix = _ref3.prefix,
      prefix = _ref3$prefix === void 0 ? "gbStickyBuckets__" : _ref3$prefix,
      req = _ref3.req,
      res = _ref3.res,
      _ref3$cookieAttribute = _ref3.cookieAttributes,
      cookieAttributes = _ref3$cookieAttribute === void 0 ? {
        maxAge: 180 * 24 * 3600 * 1000
      } : _ref3$cookieAttribute;
    _this4 = _callSuper(this, ExpressCookieStickyBucketService);
    _this4.prefix = prefix;
    _this4.req = req;
    _this4.res = res;
    _this4.cookieAttributes = cookieAttributes;
    return _this4;
  }
  _inherits(ExpressCookieStickyBucketService, _StickyBucketServiceS);
  return _createClass(ExpressCookieStickyBucketService, [{
    key: "getAssignmentsSync",
    value: function getAssignmentsSync(attributeName, attributeValue) {
      var key = this.getKey(attributeName, attributeValue);
      var doc = null;
      if (!this.req) return doc;
      try {
        var raw = this.req.cookies[key] || "{}";
        var data = JSON.parse(raw);
        if (data.attributeName && data.attributeValue && data.assignments) {
          doc = data;
        }
      } catch (e) {
        // Ignore cookie errors
      }
      return doc;
    }
  }, {
    key: "saveAssignmentsSync",
    value: function saveAssignmentsSync(doc) {
      var key = this.getKey(doc.attributeName, doc.attributeValue);
      if (!this.res) return;
      var str = JSON.stringify(doc);
      this.res.cookie(encodeURIComponent(key), encodeURIComponent(str), this.cookieAttributes);
    }
  }]);
}(StickyBucketServiceSync);
export var BrowserCookieStickyBucketService = /*#__PURE__*/function (_StickyBucketServiceS2) {
  /**
   * Intended to be used with npm: 'js-cookie'.
   * Assumes:
   *  - reading a cookie is automatically decoded via decodeURIComponent() or similar
   *  - writing a cookie name & value is automatically encoded via encodeURIComponent() or similar
   *  - all cookie bodies are JSON encoded strings and are manually encoded/decoded
   */

  function BrowserCookieStickyBucketService(_ref4) {
    var _this5;
    _classCallCheck(this, BrowserCookieStickyBucketService);
    var _ref4$prefix = _ref4.prefix,
      prefix = _ref4$prefix === void 0 ? "gbStickyBuckets__" : _ref4$prefix,
      jsCookie = _ref4.jsCookie,
      _ref4$cookieAttribute = _ref4.cookieAttributes,
      cookieAttributes = _ref4$cookieAttribute === void 0 ? {
        expires: 180
      } : _ref4$cookieAttribute;
    _this5 = _callSuper(this, BrowserCookieStickyBucketService);
    _this5.prefix = prefix;
    _this5.jsCookie = jsCookie;
    _this5.cookieAttributes = cookieAttributes;
    return _this5;
  }
  _inherits(BrowserCookieStickyBucketService, _StickyBucketServiceS2);
  return _createClass(BrowserCookieStickyBucketService, [{
    key: "getAssignmentsSync",
    value: function getAssignmentsSync(attributeName, attributeValue) {
      var key = this.getKey(attributeName, attributeValue);
      var doc = null;
      if (!this.jsCookie) return doc;
      try {
        var raw = this.jsCookie.get(key);
        var data = JSON.parse(raw || "{}");
        if (data.attributeName && data.attributeValue && data.assignments) {
          doc = data;
        }
      } catch (e) {
        // Ignore cookie errors
      }
      return doc;
    }
  }, {
    key: "saveAssignmentsSync",
    value: function () {
      var _saveAssignmentsSync = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(doc) {
        var key, str;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              key = this.getKey(doc.attributeName, doc.attributeValue);
              if (this.jsCookie) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2);
            case 1:
              str = JSON.stringify(doc);
              this.jsCookie.set(key, str, this.cookieAttributes);
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function saveAssignmentsSync(_x8) {
        return _saveAssignmentsSync.apply(this, arguments);
      }
      return saveAssignmentsSync;
    }()
  }]);
}(StickyBucketServiceSync);
export var RedisStickyBucketService = /*#__PURE__*/function (_StickyBucketService3) {
  /** Intended to be used with npm: 'ioredis'. **/

  function RedisStickyBucketService(_ref5) {
    var _this6;
    _classCallCheck(this, RedisStickyBucketService);
    var redis = _ref5.redis;
    _this6 = _callSuper(this, RedisStickyBucketService);
    _this6.redis = redis;
    return _this6;
  }
  _inherits(RedisStickyBucketService, _StickyBucketService3);
  return _createClass(RedisStickyBucketService, [{
    key: "getAllAssignments",
    value: function () {
      var _getAllAssignments2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(attributes) {
        var _this$redis;
        var docs, keys;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              docs = {};
              keys = Object.entries(attributes).map(function (_ref6) {
                var _ref9 = _slicedToArray(_ref6, 2),
                  attributeName = _ref9[0],
                  attributeValue = _ref9[1];
                return getStickyBucketAttributeKey(attributeName, attributeValue);
              });
              if (this.redis) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2, docs);
            case 1:
              _context7.n = 2;
              return (_this$redis = this.redis).mget.apply(_this$redis, _toConsumableArray(keys)).then(function (values) {
                values.forEach(function (raw) {
                  try {
                    var data = JSON.parse(raw || "{}");
                    if (data.attributeName && "attributeValue" in data && data.assignments) {
                      var key = getStickyBucketAttributeKey(data.attributeName, toString(data.attributeValue));
                      docs[key] = data;
                    }
                  } catch (e) {
                    // ignore redis doc parse errors
                  }
                });
              });
            case 2:
              return _context7.a(2, docs);
          }
        }, _callee7, this);
      }));
      function getAllAssignments(_x9) {
        return _getAllAssignments2.apply(this, arguments);
      }
      return getAllAssignments;
    }()
  }, {
    key: "getAssignments",
    value: function () {
      var _getAssignments3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(_attributeName, _attributeValue) {
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              return _context8.a(2, null);
          }
        }, _callee8);
      }));
      function getAssignments(_x0, _x1) {
        return _getAssignments3.apply(this, arguments);
      }
      return getAssignments;
    }()
  }, {
    key: "saveAssignments",
    value: function () {
      var _saveAssignments3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(doc) {
        var key;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              key = this.getKey(doc.attributeName, doc.attributeValue);
              if (this.redis) {
                _context9.n = 1;
                break;
              }
              return _context9.a(2);
            case 1:
              _context9.n = 2;
              return this.redis.set(key, JSON.stringify(doc));
            case 2:
              return _context9.a(2);
          }
        }, _callee9, this);
      }));
      function saveAssignments(_x10) {
        return _saveAssignments3.apply(this, arguments);
      }
      return saveAssignments;
    }()
  }]);
}(StickyBucketService);